<template>
  <div class="EditAddPhoneOperator">
    <el-dialog :visible.sync="dialog" @close="close">
      <el-form v-loading="loadingPage" v-if="dialog" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
        <el-form-item prop="name" label="Nome">
          <el-input size="large" v-model="ruleForm.name" required></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" style="display: flex; align-items: center; justify-content: space-between;">
        <el-button v-if="ruleForm.id" @click.prevent="delElement">Excluir</el-button>
        <div v-else></div>
        <el-button type="primary" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {deletePhoneOperator, getPhoneOperator, postPhoneOperator, putPhoneOperator} from "@/app/domains/Config/services";
import {clearRuleForm, getError, makeErrorFilds} from "@/app/plugins/utils";

export default {
  name: "dialogEditAddPhoneOperator",
  components: {
  },
  props: ['show', 'idConta'],
  watch: {
    'show': function (e) {
      this.dialog = e
    },
    'idConta': function (e) {
      if (e !== '') {
        
        this.getPhoneOperator(e)
      }
    }
  },
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      dialog: false,
      loadingPage: false,
      rules: {},
      error: {},
      ruleForm: {},
    }
  },
  methods: {
    close() {
      this.$emit('close')
      this.$refs['ruleForm'].resetFields()
      this.$refs['ruleForm'].clearValidate()
      this.ruleForm = {}
    },
    delElement () {
      this.$confirm('Deseja excluir este Banco?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        center: true,
        type: 'warning'
      }).then( async () => {
        this.loadingPage = true
        this.error = {}
        try {
          let response;
          // let query = this.$route.meta.pathAPI + '/' + this.ruleForm.id
          response = await deletePhoneOperator('/'+this.ruleForm.id)
          
          this.$message({
            showClose: true,
            message: response.message,
            type: 'success'
          })
          this.dialog = false
          this.close()
        } catch (e) {
          this.error = makeErrorFilds(e)
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {});
    },
    submitForm (ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.loadingPage = true
          this.error = {}
          try {
            let response;
            if (this.ruleForm.id !== undefined) {
              response = await putPhoneOperator(clearRuleForm(this.ruleForm))
              this.$message({
                showClose: true,
                message: 'Alterado com sucesso',
                type: 'success'
              })
            } else {
              response = await postPhoneOperator(this.ruleForm)
              this.$message({
                showClose: true,
                message: 'Adicionado com sucesso',
                type: 'success'
              })
            }
            this.dialog = false
            this.close()
          } catch (e) {
            this.error = makeErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }
      })
    },
    handleAction () {},
    async getPhoneOperator (id) {
      this.loadingPage = true
      try {
        let response = await getPhoneOperator('/'+id)
        this.ruleForm = response.data
      } catch (e) {
        
        this.$message({
          showClose: true,
          message: e.body.message,
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
